// extracted by mini-css-extract-plugin
module.exports = {"editor":"richTextEditor_editor__XpGFx"};